import React, { useState, useCallback } from 'react';
import StepDetails from 'js-promo-partners-lib/lib/components/common/step-details/step-details';
import FormInput from 'js-promo-partners-lib/lib/components/common/form-input/form-input';
import PrimaryButton from 'js-promo-partners-lib/lib/components/common/buttons/primary-button/primary-button';
import getConfig from '../../config';
import PluginAccountService from '../../services/plugin-service/plugin-account-service';
import httpClient from '../../services/http-client/http-client';
import WithApp from '../hoc/with-app/with-app';

import './app-customer-settings-page.scss';

const {
    customerKey, customerSecret, nonce, configUrl, authError, customerKeysRedirect, loginUrl,
} = getConfig();

httpClient.setNonce(undefined, nonce);
const service = new PluginAccountService(configUrl, httpClient);

const ERROR_MESSAGE = 'This field is required';

const AppCustomerSettingsPage = () => {
    const [customerSecretState, setCustomerSecret] = useState(customerSecret);
    const [customerKeyState, setCustomerKey] = useState(customerKey);
    const [customerKeyError, setCustomerKeyError] = useState('');
    const [customerSecretError, setCustomerSecretError] = useState('');

    const checkIfCanSubmit = useCallback(() => customerKeyState.length > 0 && customerSecretState.length > 0,
        [customerKeyState, customerSecretState]);

    const handleFormSubmit = useCallback(async () => {
        setCustomerKeyError('');
        setCustomerSecretError('');

        if (!checkIfCanSubmit()) {
            if (customerKeyState.length === 0) {
                setCustomerKeyError(ERROR_MESSAGE);
            }
            if (customerSecretState.length === 0) {
                setCustomerSecretError(ERROR_MESSAGE);
            }
            return;
        }

        await service.setCustomerKeys(customerKeyState, customerSecretState);
        window.location.href = customerKeysRedirect;
    }, [customerSecretState, customerKeyState]);

    const onHandleKeysReset = useCallback(async () => {
        setCustomerKey('');
        setCustomerSecret('');
        await service.setCustomerKeys('', '');
        window.open(loginUrl);
    }, []);

    return (
        <div className='app-customer-settings-page'>
            <StepDetails title='Make professional videos in minutes!' />
            <div className='app-customer-settings-page__form'>
                <p className='app-customer-settings-page__title'>
                    Paste the keys to your app settings
                </p>
                {authError && (
                    <p className='app-customer-settings-page__error'>
                        The keys are invalid
                    </p>
                )}
                <div className='app-customer-settings-page__input'>
                    <span className='app-customer-settings-page__label'>
                        Consumer key
                    </span>
                    <FormInput
                        value={customerKeyState}
                        onChange={setCustomerKey}
                        isInvalid={!!customerKeyError}
                        error={customerKeyError}
                    />
                </div>
                <div className='app-customer-settings-page__input'>
                    <span className='app-customer-settings-page__label'>
                        Consumer secret key
                    </span>
                    <FormInput
                        value={customerSecretState}
                        onChange={setCustomerSecret}
                        isInvalid={!!customerSecretError}
                        error={customerSecretError}
                    />
                </div>
                <PrimaryButton
                    className='app-customer-settings-page__submit'
                    onClick={handleFormSubmit}
                    disabled={!checkIfCanSubmit()}
                >
                    Save Changes
                </PrimaryButton>
                <p
                    className='app-customer-settings-page__reset'
                    onClick={onHandleKeysReset}
                >
                    Lost your user keys? Get a new set here
                </p>
            </div>
        </div>
    );
};

export default WithApp(AppCustomerSettingsPage);
